import React from 'react'
import MaterialSymbol from '../material-symbol'

const Payment = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="payment" {...props} />
))

Payment.displayName = 'Payment'

export default Payment
